module.exports = __webpack_public_path__ + "img/t4-black.264f669d.png";